import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './forgotten-password.css';
import { AxiosResponse } from 'axios';
import { isValidEmail } from '../../../../../utils/is-valid-email/is-valid-email';
import { showLoadingAlertMessage } from '../../../../../utils/show-loading-alert-message/show-loading-alert-message';
import { networkCall } from '../../../../../utils/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../utils/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../redux/reducer/alert-message.reducer';
import { DefaultErrorResponse } from '../../../../../types/api/error/default-error-response/default-error-respose.type';
import { ValidationErrorResponseData } from '../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.';
import { EmailInput } from '../../../../../components/field/email-input/email-input';
import { getImageUrl } from '../../../../../utils/image-helper/get-image-url';

export const ForgottenPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState({
        value: '',
        error: ''
    });

    const validateForm = () => {
        setEmail({
            value: email.value,
            error: ''
        })

        if (!email.value) {
            setEmail({
                value: email.value,
                error: 'Mező kitöltése kötelező.'
            })
            return false;
        }

        if (!isValidEmail(email.value)) {
            setEmail({
                value: email.value,
                error: 'Helytelen email formátum.'
            });
            return false;
        }

        return true;
    };

    const handleSendRequestButtonClick = async () => {
        if (!validateForm()) return;

        showLoadingAlertMessage();

        const response = await networkCall('/users/request-password-reset', {
            method: 'POST',
            body: {
                email: email.value
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: 'Ismeretlen hiba történt. Kérjük próbálja újra!'
        };

        if (response?.status === 200) {
            navigate('/cms/login');
            alertMessageState.alertMessageType = 'success';
            alertMessageState.alertMessageText = 'Jelszavának megváltozatásához szükséges információt a megadott email címre elküldtük.';
        } else if(response?.status === 400) {

            const _res: AxiosResponse<DefaultErrorResponse> = response;

            switch (_res.data.code) {
                case 1000:
                    const res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'HibáSan megadott beviteli mezők.';
                    if(res.data.data) {
                        for (const element of res.data.data) {
                            setEmail({
                                value: email.value,
                                error: element.errors.join(', ')
                            })
                            break;
                        }
                    }
                    break;
            }

        } else if (response?.status === 404) {
            alertMessageState.alertMessageText = 'Hibás email cím.';
        }

        dispatch(showAlertMessage(alertMessageState));
    };

    return (
        <div className="forgotten-password-container">
            <div className="title">Elfelejtett jelszó</div>
            <div className='body'>
                <EmailInput
                    id="email"
                    name="email"
                    value={email.value}
                    onChange={(value) => setEmail({ value, error: '' })}
                    placeholder="email cím"
                    error={email.error}
                    icon={getImageUrl('user-icon.png')}
                />

                <button className="forgotten-password-btn" onClick={handleSendRequestButtonClick}>Email küldése</button>

                <Link to='/cms/login' className="login-link">Vissza</Link>
            </div>
        </div>
    );
};